export default "__VITE_ASSET__c9430773__"